'use strict'

import { ConversationalForm } from 'conversational-form'

export const Forms = (() => {
    const formEl = document.getElementById('quickscan_co2_rapportage_form')
    const context = document.getElementById('quickscan_co2_rapportage_wrapper')
    const restartEl = document.getElementById('quickscan_co2_rapportage_restart')

    let formData
    let questions = {};

    const gaCategory = 'CO2-rapportage Quickscan';
    const init = () => {
        if(!formEl || !context) return

        window.conversationalForm = new ConversationalForm({
            formEl,
            context,
            preventAutoStart: true,
            preventAutoFocus: true,
            loadExternalStyleSheet: false,
            showProgressBar: true,
            hideUserInputOnNoneTextInput: false,
            robotImage: '/assets/bcs-corporate/dist/corporate-nieuw/img/svg/Beeldmerk HR Software.svg',
            userImage: '/assets/bcs-corporate/dist/corporate-nieuw/img/svg/Person.svg',
            flowStepCallback: (dto, success, error) => stepCallback(dto, success, error),
            submitCallback: () => submitCallback(),
        })

        const conversationalFormDiv = document.getElementById('conversational-form')

        if(!conversationalFormDiv) return

        const inteersectionObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.isIntersecting) {
                    if(entry.target.id == 'conversational-form') {
                        window.conversationalForm.start()
                    }

                    inteersectionObserver.unobserve(entry.target)
                }
            })
        }, {
            threshold: 0.8,
        })

        inteersectionObserver.observe(conversationalFormDiv)

        if(!restartEl) return

        const restartButton = restartEl.querySelector('button')
        
        if(!restartButton) return

        restartButton.addEventListener('click', () => {
            restartConversation()
        })
    }

    const stepCallback = (dto, success, error) => {
        // TODO: gtagStep(dto)

        getFormData()

        // Check for special cases
        if(questions['q2'] == 'b' && questions['q5'] == 'b' && questions['q8'] == 'b' && questions['q10'] == 'b') {
            submitRobotResponse('2b_5b_8b_10b')
            stopConversation()
        }

        // Field validation
        switch(dto.tag.name) {
            case 'voornaam':
            case 'achternaam':
                return nameValidation(dto.tag.value, success, error)

            case 'telefoonnummer':
                return phoneValidation(dto.tag.value, success, error)
        }

        return success()
    }

    const submitCallback = () => {
        getFormData()

        try {
            const exitPoint = getExitPoint()

            if(exitPoint > 0) {
                submitRobotResponse(exitPoint)
                stopConversation()
            } else {
                submitRobotResponse('before_submit')

                const body = new FormData()

                if(CSRF_TOKEN && CSRF_TOKEN_NAME) {
                    body.append(CSRF_TOKEN_NAME, CSRF_TOKEN)
                }

                var transcriptie = "";
                try {
                    const transcript = [];
                    $('cf-chat-response').each(function(i, el){
                        if (el.classList.contains('robot')) {
                            const Text = $($('cf-chat-response')[i]).find('p.show').text();
                            transcript.push(Text);
                        }
                        else {
                            const Text = $($('cf-chat-response')[i]).find('p.show').text();
                            transcript.push(Text);
                        }
                    });
                    transcriptie = JSON.stringify(transcript);
                }
                catch (e){
                    console.log(e);
                }

                body.append('sectionId', 50)
                body.append('enabled', true)
                body.append('title', 'CO2-rapportage Quickscan')
                body.append('fields[questions]', JSON.stringify(questions))
                body.append('fields[transcriptie]', JSON.stringify(transcriptie))
                body.append('fields[voornaam]', formData['voornaam'])
                body.append('fields[achternaam]', formData['achternaam'])
                body.append('fields[email]', formData['email'])
                body.append('fields[telefoonnummer]', formData['telefoonnummer'])
                body.append('fields[bedrijfsnaam]', formData['bedrijfsnaam'])
                body.append('fields[aantalMedewerkers]', formData['aantalMedewerkers'])
                
                // Submitting | only one of the csrf is needed 
                fetch('/actions/guest-entries/save', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-TOKEN': CSRF_TOKEN,
                        CSRF_TOKEN_NAME: CSRF_TOKEN,

                    },
                    body
                })
                .then(response => response.json())
                .then(data => {
                    if(data.success) {
                        submitRobotResponse('after_submit')
                    } else {
                        window.conversationalForm.addRobotChatResponse('Er ging wat mis bij het verzenden van het rapport. Probeer het later opnieuw')
                    }
                })
            }
        } catch(error) {
            console.log(error);
        }

        // TODO: gtagSubmit()
    }

    const stopConversation = () => {
        window.conversationalForm.stop()

        const progressBar = document.querySelector('.cf-progressBar .bar')

        if(!progressBar) return

        progressBar.style.width = '100%'

        window.conversationalForm.el.classList.add('done')
    }

    const restartConversation = () => {
        restartEl.classList.remove('active')

        const chatInner = context.querySelector('.scrollableInner')

        if(!chatInner) return

        // Clean the chat
        while(chatInner.firstChild) chatInner.removeChild(chatInner.firstChild)

        window.conversationalForm.remapTagsAndStartFrom(0, false, true)

        if(window.conversationalForm.el.classList.contains('done')) {
            window.conversationalForm.start()
            window.conversationalForm.el.classList.remove('done')
        }
    }

    const getFormData = () => {
        formData = window.conversationalForm.getFormData(true)

        getQuestions()
    }

    const getQuestions = () => {
        const qKeys = Object.keys(formData).filter(key => /^q/.test(key))
        
        qKeys.forEach(key => {
            questions[key] = formData[key][0];
        });
        // console.log(questions);
    }

    const submitRobotResponse = exitPoint => {
        const exitPointDiv = document.getElementById('quickscan_co2_rapportage_form_exit_' + exitPoint)

        if(!exitPointDiv) {
            throw 'Exit point ' + exitPoint + ' template not found'
        }

        window.conversationalForm.addRobotChatResponse(exitPointDiv.innerHTML.trim())

        if(!restartEl) return

        restartEl.classList.add('active')
    }


    const nameValidation = (value, success, error) => {
        const mask = /^[\p{Letter}\s\-.']+$/u
        const testResult = mask.test(value)

        if(!testResult) return error()

        return success()
    }

    const phoneValidation = (value, success, error) => {
        const mask = /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/gi
        const testResult = mask.test(value)

        if(!testResult) return error()

        return success()
    }

    const getExitPoint = () => {
        const exitIndex = Object.values(questions).lastIndexOf('exit')

        if(exitIndex == -1) return 0

        return parseInt(Object.keys(questions)[exitIndex].replace(/[^0-9]/g, ''))
    }

    const gtagStep = dto => {
        if(window.google_tag_manager) {
            const currentStep = window.conversationalForm.flowManager.getStep()
            const maxSteps = window.conversationalForm.flowManager.maxSteps

            gtag('event', 'CF event', {
                event_category: gaCategory,
                event_action: 'Step' + currentStep + '/' + maxSteps,
                event_label: 'Field name - ' + dto.tag.name
            })
        }
    }

    const gtagSubmit = () => {
        if(window.google_tag_manager) {
            gtag('event', 'CF event', {
                event_category: gaCategory,
                event_action: 'Form completed'
            })
        }
    }

    return {
        init
    }
})()